import { render, staticRenderFns } from "./statics.vue?vue&type=template&id=0659ddb8&scoped=true"
import script from "./statics.vue?vue&type=script&lang=js"
export * from "./statics.vue?vue&type=script&lang=js"
import style0 from "./statics.vue?vue&type=style&index=0&id=0659ddb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0659ddb8",
  null
  
)

export default component.exports